import { HubItemMediaPreviewViewModel } from "client/Api/Hub/common";
import { TimeZone } from "client/DateAndTime/timezones";
import { ReactElement, useMemo } from "react";
import { convertHubCategory, convertHubMedia } from "client/Features/Search/RecentSearch/Persistence/convertPersistedData";
import { HubItemCategoryListItemModel } from "client/Api/Hub/hub";
import { generateTrackingId } from "client/Misc/utils";
import { AnnouncementListItem } from "client/Features/Hub/Announcements/ListItem/AnnouncementListItem";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { useAnnouncementNavigationHandler } from "../../../Navigation/useAnnouncementNavigationHandler";
import { ValidGlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/validation";

export type AnnouncementItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.Announcement>;
	itemIndex: number;
	onRemove: () => void;
	timezone: TimeZone;
	tabIndex: number;
};

export const AnnouncementItemView = (props: AnnouncementItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		onRemove,
		timezone,
		tabIndex
	} = props;

	const {
		id,
		title,
		media: persistedMedia,
		authorName,
		publicationStart,
		categories: persistedCategories
	} = item.announcement;

	const media = useMemo(
		(): HubItemMediaPreviewViewModel => convertHubMedia(persistedMedia),
		[persistedMedia]
	);

	const categories = useMemo(
		(): readonly HubItemCategoryListItemModel[] => persistedCategories.map(c => convertHubCategory(c)),
		[persistedCategories]
	);

	const openHandler: () => void = useAnnouncementNavigationHandler({
		id,
		recentlyOpenedItem: item
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("announcement-item", `|${id}`)}
			onClick={openHandler}
		>
			<AnnouncementListItem
				title={title}
				authorName={authorName}
				publicationStart={publicationStart}
				media={media}
				categories={categories}
				timezone={timezone}
				trackingId={generateTrackingId("announcement-result-list-item", `|${id}`)}
				onRemove={onRemove}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};
AnnouncementItemView.displayName = "AnnouncementItemView";